import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import Button from '@/components/Button/Button';
import { ButtonVariants } from '@/components/Button/Button.types';
import { useNavigate } from 'react-router-dom';
import { useSTKContext } from '@/context/context';
import useFranchiseeAlias from '@/utils/useFranchiseeAlias/useFranchiseeAlias';
import styles from './BundleAddOnsHeader.module.css';

export interface BundleAddOnsHeaderProps {
  totalStoreCount: number;
}

const BundleAddOnsHeader: FC<BundleAddOnsHeaderProps> = ({ totalStoreCount }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { storesAndGroups } = useSTKContext();
  const { alias } = useFranchiseeAlias();
  const [hasHorizontalScrollbar, setHasHorizontalScrollbar] = useState(false);
  const [mobileViewScreen, setMobileViewScreen] = useState(false);

  const getTotalStoresGroupSelected = () => {
    let total = 0;
    storesAndGroups?.storeGroups?.forEach((group) => {
      total += group.stores.length;
    });
    return total;
  };

  const selectedCount =
    (storesAndGroups?.stores?.length ?? 0) > 0 ? storesAndGroups?.stores?.length ?? 0 : getTotalStoresGroupSelected();

  const isDisabled = (storesAndGroups?.stores?.length ?? 0) === 0 && (storesAndGroups?.storeGroups?.length ?? 0) === 0;

  useEffect(() => {
    const handleScroll = () => {
      setHasHorizontalScrollbar(window.scrollY > 100);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setMobileViewScreen(window.innerWidth < 768);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div
      className={classNames(hasHorizontalScrollbar ? styles.stickyHeaderShadow : styles.stickyHeader, {
        [styles.withAlias]: !alias,
      })}
    >
      <div className={styles.menuTitleHeader}>
        <div className={styles.leftHeaderLabel}>
          <div className={styles.storeMenusText}>{t('franchiseeBundleAddOns.selectStoreLabel')}</div>
        </div>
        {!hasHorizontalScrollbar && !mobileViewScreen && (
          <div className={styles.labelRightButton}>
            <Button
              variant={ButtonVariants.Primary}
              onClick={() => navigate('/bundles/add-ons/view')}
              disabled={isDisabled}
            >
              {t('franchiseeBundleAddOns.manageButton')}
            </Button>
            <div className={styles.storesSelected}>
              {t('franchiseeBundleAddOns.storesSelected', {
                count: selectedCount,
                size: totalStoreCount,
              })}
            </div>
          </div>
        )}
        {(hasHorizontalScrollbar || mobileViewScreen) && (
          <div className={styles.labelLeftButton}>
            <div className={styles.storesSelected}>
              {t('franchiseeBundleAddOns.storesSelected', {
                count: selectedCount,
                size: totalStoreCount,
              })}
            </div>
            <Button
              variant={ButtonVariants.Primary}
              onClick={() => navigate('/bundles/add-ons/view')}
              disabled={isDisabled}
            >
              {t('franchiseeBundleAddOns.manageButton')}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default BundleAddOnsHeader;
